









import Oidc from 'oidc-client';
import { Component, Vue } from 'vue-property-decorator';
import * as config from '@/utils/config';
// var mgr = new Oidc.UserManager({userStore: new Oidc.WebStorageStateStore(), loadUserInfo: true});

@Component
export default class Callback extends Vue {

    loginRequired = false;

    created() {
        console.log("Callback component.");
        new Oidc.UserManager({ userStore: new Oidc.WebStorageStateStore({}) })
            .signinRedirectCallback()
            .then(() => {
                console.log("We have the user.");
                window.location.href = config.POST_LOGOUT_REDIRECT_URI;
            }).catch((err) => {
            console.log(err);
            this.loginRequired = true;
        });
    }
}
